export const matjungelenGreen = '#365e1b';
export const matjungelenDarkGreen = '#123f22';
export const matjungelenAmber = '#fbf5e8';
export const matjungelenLightGreen = '#daedb6';
